// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import api from '@/api/http.api.js'
import { Button, Card, Row, Col, Image, Input, Avatar, Form, FormItem, Pagination, Icon} from 'element-ui';
Vue.config.productionTip = false
Vue.use(Button)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Icon)
Vue.use(Image)
Vue.use(Input)
Vue.use(Avatar)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Pagination)
Vue.prototype.$api = api
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js